const mappingIdentity = (mapping) => {
  const identity = mapping.stop_external_id || `legacy code ${mapping.legacy_stop_code}`
  return `${mapping.feed_key} / ${identity}`
}

export function snapshotHubPreviewLines (hub) {
  const lines = [`${hub.hub_type || 'unknown'} hub ${hub.hub_external_id || 'unknown'} — ${hub.status}`]
  const changes = hub.changes || {}

  ;(changes.add || []).forEach((mapping) => lines.push(`Add: ${mappingIdentity(mapping)}`))
  ;(changes.remove || []).forEach((mapping) => lines.push(`Remove: ${mappingIdentity(mapping)}`))
  ;(changes.retain_code_only || []).forEach((mapping) => {
    const group = mapping.group_key ? ` → ${mapping.group_key} (${mapping.group_name})` : ' → standalone'
    lines.push(`Retain code-only: ${mapping.feed_key} / ${mapping.legacy_stop_code}${group}`)
  })
  ;(changes.unresolved_mappings || []).forEach((mapping) => lines.push(`Unresolved exact ID: ${mappingIdentity(mapping)}`))
  ;(changes.groups || []).forEach((group) => {
    const list = (members) => members.length ? members.map(mappingIdentity).join(', ') : 'none'
    const nameBefore = group.name_before || 'none'
    const nameAfter = group.name_after || 'none'
    const anchorBefore = group.anchor_before ? mappingIdentity(group.anchor_before) : 'none'
    const anchorAfter = group.anchor_after ? mappingIdentity(group.anchor_after) : 'none'
    lines.push(`Group ${group.group_key}: name "${nameBefore}" → "${nameAfter}"; members before [${list(group.members_before)}] → after [${list(group.members_after)}]; added [${list(group.members_added)}]; removed [${list(group.members_removed)}]; anchor ${anchorBefore} → ${anchorAfter}`)
  })
  ;(hub.reasons || []).forEach((reason) => lines.push(`Skipped: ${reason}`))

  return lines
}
